const MULBERRY32_INCREMENT = 0x6d2b79f5
const UINT32_RANGE = 0x100000000

/** mulberry32: a seedable PRNG yielding a deterministic float stream in [0, 1). */
const mulberry32 = (seed: number): (() => number) => {
  let state = seed >>> 0
  return () => {
    state = (state + MULBERRY32_INCREMENT) >>> 0
    let mixed = state
    mixed = Math.imul(mixed ^ (mixed >>> 15), mixed | 1)
    mixed ^= mixed + Math.imul(mixed ^ (mixed >>> 7), mixed | 61)
    return ((mixed ^ (mixed >>> 14)) >>> 0) / UINT32_RANGE
  }
}

/** Generates a random 32-bit seed suitable for `seededShuffle`. */
export const randomSeed = (): number => Math.floor(Math.random() * UINT32_RANGE)

/**
 * Deterministic Fisher-Yates shuffle: the same seed always reproduces the same
 * ordering, so a randomized feed can be reconstructed from the seed logged in
 * analytics (SUP-504).
 */
export const seededShuffle = <T>(items: T[], seed: number): T[] => {
  const nextRandom = mulberry32(seed)
  const shuffled = [...items]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(nextRandom() * (i + 1))
    const atI = shuffled[i]
    shuffled[i] = shuffled[j]
    shuffled[j] = atI
  }
  return shuffled
}
